import React from 'react';
import { Button, Result } from 'antd';
import { Link} from "react-router-dom";

function SignUpSuccess() {
  return (
    <div id="about" className="block aboutBlock">
      <div className="container-fluid">
    <Result
    style={{minHeight:'380px'}}
    status="success"
    title="Successfully Registered your account"
    subTitle="Thank you for using our services, you can now log in to view your profile."
    extra={[
       <Link to='/SignIn'>
       <Button type="primary" key="console">Log In</Button>
      </Link>,
    ]}
  />
  </div>
  </div>
  )
}

export default SignUpSuccess